export const COOKIE_CUSTOMER_ID = "customerId";
export const COOKIE_ADDRESS = "address";
export const COOKIE_SHOP_ID = "shopId";
export const COOKIE_ORDER_TYPE = "orderType";
